import React from "react";
import { Container, Row, Col } from "react-bootstrap";
import Cards from "./Cards";

const Requirements = () => {
  return (
    <Container
      className="howitworks text-center bg-dark text-white py-5 z-1"
      id="requirements"
      fluid
    >
      <h1 className="fw-bolder mb-5">REQUIREMENTS</h1>
      <Row>
        <Col lg={6}>
          <Cards
            title={"Commitment"}
            text={
              "Must be a committed member of the community"
            }
          />
        </Col>
        <Col lg={6}>
          <Cards
            title={"Consistent"}
            text={
              "Regular monthly contributions to sustain the fund"
            }
          />
        </Col>
        <Col lg={6}>
          <Cards
            title={"Agreement"}
            text={"Agree to a transparent selection and repayment process"}
          />
        </Col>
        <Col lg={6}>
          <Cards
            title={"Referral"}
            text={
              "Referral of at least one new member to keep the fund growing"
            }
          />
        </Col>
      </Row>
    </Container>
  );
};

export default Requirements;
